import React from 'react';
import PropTypes from 'prop-types';
import InsightsOutlinedIcon from '@mui/icons-material/InsightsOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import GuideCallout, { GuideCalloutOption } from '../shared/GuideCallout';

const STEPS = {
  watchlist: {
    title: 'Start with your Watchlist',
    subtitle: 'Add the securities you follow. Your portfolio and position sizing build on it.',
    Icon: VisibilityOutlinedIcon,
    label: 'Open Watchlist',
    detail: 'Upload a file or add securities there',
  },
  portfolio: {
    title: 'Next: import your portfolio',
    subtitle: 'Your Watchlist is ready. Import the positions you hold to see their risk.',
    Icon: InsightsOutlinedIcon,
    label: 'Open Risk Overview',
    detail: 'Portfolio imports are in its top bar',
  },
};

/**
 * Speech-bubble guide for the next setup step while the user is on another
 * page. It points at that step's tab in the side menu (on narrow screens, at
 * the button that opens the menu) and its button opens the tab. It waits
 * while another guide is showing.
 */
export default function SetupStepHint({ step, open, anchorEl, onOpen, onDismiss }) {
  const content = STEPS[step];
  if (!content) return null;
  const { Icon } = content;
  return (
    <GuideCallout
      open={open}
      anchorEl={anchorEl}
      ariaLabel={content.title}
      title={content.title}
      subtitle={content.subtitle}
      onDismiss={onDismiss}
      waitForOtherGuides
    >
      <GuideCalloutOption
        icon={<Icon sx={{ fontSize: 18 }} />}
        label={content.label}
        detail={content.detail}
        onClick={onOpen}
      />
    </GuideCallout>
  );
}

SetupStepHint.propTypes = {
  step: PropTypes.oneOf(['watchlist', 'portfolio']),
  open: PropTypes.bool.isRequired,
  anchorEl: PropTypes.object,
  onOpen: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
};
